<!-- rot, grün, gelb, ... Alarme anzeigen und das Ergebnis -->
<template>

    <span class="ErgebnisColorAndValue" v-if="alarm_level">
        <b-alert show
                 style="padding:0 1.25rem"
                 :variant="color">

            <span v-if="result_value">
               {{ formattedResultValue }}
            </span>
            <span v-else-if="notCheckable">
                <b-icon icon="lightning" />&nbsp;{{ $t('message.charts_nicht_pruefbar') }}
            </span>

        </b-alert>
    </span>

</template>

<script>

    export default {

      name: 'ErgebnisColorAndValueNoChart',
      props: ['alarm_level', 'result_value', 'task_ergebnis_id', 'notCheckable', 'isTuerSensor'],
      computed: {

        formattedResultValue: function() {

          const num = parseFloat(this.result_value)

          // Türsensor: 1=geschlossen(GRUEN), 0=geöffnet innerhalb Toleranz(GELB), 2=geöffnet über Schwellwert(ROT)
          if (this.isTuerSensor) {
            if (num === 1) return this.$t('message.sensor_tuer_geschlossen')
            if (num === 0) return this.$t('message.sensor_tuer_offen_toleranz')
            if (num === 2) return this.$t('message.sensor_tuer_offen_schwellwert')
            return this.$t('message.sensor_tuer_keine_daten')
          }

          if (!isNaN(num) && String(this.result_value).includes('.')) {
            return num.toFixed(1)
          }
          return this.result_value
        },

        color: function() {

          if (this.alarm_level) {
            if (this.alarm_level == 'GRUEN') {
              return 'success'
            }
            if (this.alarm_level == 'ROT') {
              return 'danger'
            }
            if (this.alarm_level == 'GELB') {
              return 'warning'
            }
          }
          return 'secondary'

        }

      }

    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .btn {
        /*min-height: 25px;*/
        width: 100%;
    }

</style>
